import React from 'react'

import { Form, Input, InputNumber, Select } from 'antd'
import PropTypes from 'prop-types'

const TwoColorsForm = ({
  form,
  index,
  code_1,
  code_2,
  status,
  setAudioFile,
  setImageFile,
  audioFileRef,
  imageFileRef
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <div style={{ marginBottom: '3%' }}>
        <>Аудио</>
        <input
          type="file"
          accept="audio/*"
          ref={audioFileRef}
          onChange={event => {
            setAudioFile(event.target.files[0])
          }}
        />
        <>Изображение</>
        <input
          type="file"
          accept="image/*"
          ref={imageFileRef}
          onChange={event => setImageFile(event.target.files[0])}
        />
      </div>
      <FormItem
        key="index"
        label="Очередность"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите Очередность Документа`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность" />
      </FormItem>
      <FormItem
        key="status"
        label="Статус"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="active" value="active">
            Автивный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="code_1"
        label="Код 1"
        name="code_1"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите код цвета`
          }
        ]}
        initialValue={code_1}
      >
        <Input placeholder="Код" />
      </FormItem>
      <FormItem
        key="code_2"
        label="Код 2"
        name="code_2"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите код цвета`
          }
        ]}
        initialValue={code_2}
      >
        <Input placeholder="Код" />
      </FormItem>
    </Form>
  )
}

TwoColorsForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired
}

TwoColorsForm.defaultProps = {
  letter: '',
  status: 'active'
}

export default TwoColorsForm
